import axios from 'axios'
import get from 'lodash/fp/get'
import Toaster from '@/utils/toaster'
import { isInvestorView } from '@/axios/investor-view'

const api = axios.create({})

const is4xxError = status => status >= 400 && status < 500
const isServerUnavailableError = status => status === 502 || status === 503

const investorViewRequestInterceptor = config => {
  if (isInvestorView()) {
    config.params = { ...(config.params || {}), investor_view: true }
  }
  return config
}

api.interceptors.request.use(investorViewRequestInterceptor)
// Many store actions use the bare `axios` default instance directly, so the
// flag must be injected there as well — otherwise those calls would skip the
// investor-view filtering.
axios.interceptors.request.use(investorViewRequestInterceptor)

api.interceptors.response.use(
  response => {
    const { data } = response
    if (data && data.response_message) {
      Toaster.show([{ type: 'success', text: data.response_message }])
    }
    if (response.data.data) {
      response.data = response.data.data
    }
    return response
  },
  error => {
    if (axios.isCancel(error)) {
      return new Promise(() => {})
    }
    const status = get('response.status', error)
    const errorMessage = get('response.data.error', error) || error.message
    const method = get('response.config.method', error)
    if (is4xxError(status) && method !== 'get') {
      if (errorMessage) {
        Toaster.show([{ type: 'error', text: errorMessage }])
      }
    } else if (isServerUnavailableError(status)) {
      // Import store dynamically to avoid circular dependency
      import('@/store').then(({ store }) => {
        store.dispatch('updateShowServerErrorModal')
      })
    }
    throw error
  }
)

const axiosCancelable = {}

api.cancel = function (key) {
  if (axiosCancelable[key]) {
    axiosCancelable[key].cancel()
  }
}

api.cancelToken = function (key) {
  const CancelToken = axios.CancelToken
  const source = CancelToken.source()
  axiosCancelable[key] = source
  return source.token
}

const autoCancelToken = function (key) {
  api.cancel(key)
  return api.cancelToken(key)
}
api.autoCancelToken = autoCancelToken

export default api
export { autoCancelToken }
